$(document).ready(function() {
    // Add click event handler using event delegation
    $(document).on('click', '.load-more-primary', function() {
      
        // Get the ID of the clicked button
        var buttonId = $(this).attr('id');
        console.log("click from " + buttonId);
        
        // Find the closest carousel item to the button clicked
        var carouselItem = $(this).closest('.featured-collections-carousel__item');

        // Select all hidden product cards within the carousel item
        var hiddenProductCards = carouselItem.find('.product-card.hide');

        // Iterate through the next 8 hidden product cards
        for (var i = 0; i < 8; i++) {
            // Check if there are still hidden product cards
            if (hiddenProductCards.length > 0) {
                // Remove the hide class from the next hidden product card
                hiddenProductCards.eq(0).removeClass('hide');
                // Update hiddenProductCards variable to exclude the revealed card
                hiddenProductCards = carouselItem.find('.product-card.hide');
            } else {
                // If there are no more hidden product cards, hide the current "Load More" button
              // Get the data-next attribute value
        var nextPageUrl = $(this).attr('data-next');
        
        // Check if data-next attribute is present
        if (!nextPageUrl == "no-page") {
            // Reference to the current button
            var loadMoreButton = $(this);

            // Make an AJAX request to load the next page
            $.ajax({
                url: nextPageUrl,
                type: 'GET',
                dataType: 'html',
                success: function(data) {
                    // Find the product list container
                    var productList = loadMoreButton.closest('.product-list');

                    // Append the newly loaded product cards to the product list
                    productList.append($(data).find('.product-list').children());

                    // Hide the current "Load More" button if there are no more pages
                    var nextUrl = $(data).find('.load-more-primary').attr('data-next');
                    if (!nextUrl) {
                        loadMoreButton.hide();
                    }

                    // Add hide class to the newly appended product cards
                    productList.find('.product-card').addClass('hide');
                },
                error: function(xhr, status, error) {
                    console.error('Error loading next page:', error);
                }
            });
        } else {
                $(this).hide();
        }
                break;
            }
        }
    });
});

const swiper = new Swiper('.swiper', {
  // Optional parameters
  direction: 'horizontal',
  loop: false,
  slidesPerView: 1.5,
  autoplay: {
     delay: 5000,
  }

  // If we need pagination
  /*pagination: {
    el: '.swiper-pagination',
  },*/

  // Navigation arrows
  /*navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }*/

  // And if we need scrollbar
  /*scrollbar: {
    el: '.swiper-scrollbar',
  },*/
});

// =================================================================
// DINT 2026 round-3 — collection tab-nav active-link highlighting
// (moved out of main-collection.liquid so the section template stays
// minimal and updates from upstream Prestige don't fight with us)
// =================================================================
document.addEventListener('DOMContentLoaded', function () {
  var current = location.pathname;
  document.querySelectorAll('.menu_in_collection_by_meta .metafield-rich_text_field p a').forEach(function (a) {
    var href = a.getAttribute('href');
    if (href && current.indexOf(href) !== -1) {
      a.classList.add('active');
    }
  });
});
